// extracted by mini-css-extract-plugin
export default {"recos":"W3-z","productCardOverride":"X3-z","rowHasBadge":"Y3-z"};